module.exports = __webpack_public_path__ + "static/awards-logo6-abb3f6dda0242c31f106107a869c1e43.jpg";